import { atom } from 'jotai';

export const submenuStateAtom = atom(false);

export const getSubmenuStateAtom = atom(
  (get) => get(submenuStateAtom),
  (_get, set, isOpen: boolean) => {
    set(submenuStateAtom, isOpen);
  }
);
